export function isShorttermParking(poiType, poiResult) {
    return poiType === 'shorttermparking' || poiResult.subType === 'shorttermparking' || poiResult.type === 'SHORTTERMPARKING'
}